<template>
  <div class="bigbox">
    <el-form ref="form1" :model="form" label-width="120px"
             v-if="form.productType === 1 || containPhysicalAndServiceProduct">
      <!-- <el-form-item label="签单员工：">
        <div>{{ form.province + form.companyName + form.salesman }}</div>
      </el-form-item> -->

      <el-form-item label="签单员工：">
        <div>
          <span v-if="form.province && form.companyName && form.salesman" class="spanorder">
            {{ form.province + form.companyName + form.salesman }}
          </span>
          <span v-else class="spanorder">
            <span v-if="this.sysUser.sysUserRole === 0"> </span>
            <span v-else>
              {{
                this.sysUser.regionName +
                this.sysUser.departmentName +
                this.sysUser.realName
              }}
            </span>
          </span>
          <el-button type="text" style="font-size: 14px; margin-left: 20px" @click="chooseuser">选择</el-button>
        </div>
      </el-form-item>

      <div class="title" style="width: 862px" v-if="containPhysicalAndServiceProduct">
        <span class="titleline"></span>
        <span class="titletext">收货信息</span>
      </div>

      <el-form-item label="是否取货：">
        <el-radio-group v-model="form.isGet">
          <el-radio :label="0">是</el-radio>
          <el-radio :label="1">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="收货人：" v-if="form.isGet === 1">
        <el-input v-model="address.consignee" placeholder="收货人" size="small" clearable style="width: 150px">
        </el-input>
      </el-form-item>

      <el-form-item label="收货电话：" v-if="form.isGet === 1">
        <el-input v-model="address.telephone" placeholder="收货" size="small" clearable style="width: 150px">
        </el-input>
      </el-form-item>

      <el-form-item label="邮寄地址：" v-if="form.isGet === 1">
        <el-select clearable v-model="address.province" placeholder="省" class="input1" size="small"
                   @change="changeprovince" value-key="id">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item">
          </el-option>
        </el-select>

        <el-select clearable v-model="address.city" placeholder="市" class="input1" size="small" @change="changecity"
                   value-key="id">
          <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item">
          </el-option>
        </el-select>

        <el-select clearable v-model="address.area" placeholder="区县" class="input1" size="small" value-key="id">
          <el-option v-for="item in county" :key="item.id" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="详细地址：" v-if="form.isGet === 1">
        <el-input v-model="address.address" placeholder="请输入详细地址" size="small" clearable style="width: 490px">
        </el-input>
      </el-form-item>
    </el-form>

    <el-form ref="form" :model="user" label-width="120px"
             v-if="form.productType !== 1 || containPhysicalAndServiceProduct">
      <el-form-item label="签单员工：" v-if="form.productType !== 1 && !containPhysicalAndServiceProduct">
        <div>
          <span v-if="form.province && form.companyName && form.salesman" class="spanorder">
            {{ form.province + form.companyName + form.salesman }}
          </span>
          <span v-else class="spanorder">
            <span v-if="this.sysUser.sysUserRole === 0"> </span>
            <span v-else>
              {{
                this.sysUser.regionName +
                this.sysUser.departmentName +
                this.sysUser.realName
              }}
            </span>
          </span>
          <el-button type="text" style="font-size: 14px; margin-left: 20px" @click="chooseuser">选择</el-button>
        </div>
      </el-form-item>

      <div class="title" style="width: 862px" v-if="containPhysicalAndServiceProduct">
        <span class="titleline"></span>
        <span class="titletext">学生信息</span>
      </div>

      <el-row>
        <el-col :span="8">
          <el-form-item label="学生姓名：">
            <el-input v-model="user.realName" size="small" disabled style="width: 200px"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="身份证号码：" prop="identityNumber">
            <el-input
              v-model="user.identityNumber"
              size="small"
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="服务电话：">
            <el-input v-model="user.servicePhone" disabled size="small" style="width: 200px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="性别：" prop="sex">
            <el-radio-group v-model="user.sex">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="民族：">
            <el-select v-model="user.nation" placeholder="请选择" size="small" style="width: 200px">
              <el-option v-for="item in nationData" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="毕业年份：">
            <el-select v-model="user.graduateYear" placeholder="请选择" size="small" @change="handelchange"
                       style="width: 200px">
              <el-option v-for="item in yearsoptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="就读学校：" prop="schoolName">
            <el-input v-model="user.schoolName" disabled size="small" placeholder="请选择学校"
                      style="width: 200px; margin-right: 20px"></el-input>
            <el-button size="small" type="text" style="font-size: 14px" @click="showschool">选择</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属公司：">
            <el-select :disabled="disabled3" v-model="user.company" placeholder="请选择" size="small"
                       value-key="companyId"
                       style="width: 200px">
              <el-option v-for="item in companyoptions" :key="item.companyId" :label="item.companyName" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="户籍省份:">
            <el-select @change="changeprovince" v-model="user.residenceProvince1" placeholder="全部" class="select"
                       size="small" value-key="id" style="width: 200px">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="户籍城市:" prop="residenceCity1">
            <el-select clearable v-model="user.residenceCity1" @change="changecity" placeholder="全部" class="select"
                       size="small" value-key="id" style="width: 200px">
              <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="户籍区域:">
            <el-select clearable v-model="user.residenceCounty" placeholder="全部" class="select" size="small"
                       style="width: 200px">
              <el-option v-for="item in county" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="高考省份:">
            <el-select :disabled="disabled2" v-model="gkProvince" @change="gkprovincechange"
                       placeholder="请选择高考省份"
                       size="small" style="width: 200px" value-key="id">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="高考模式：">
            <div v-if="pattern === 1">3 + 3</div>
            <div v-if="pattern === 2">3 + 1 + 2</div>
            <div v-if="pattern === 3">文理分科</div>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="pattern === 3">
          <el-form-item label="选考科目：">
            <el-radio :label="2" v-model="user.disciplineType">文科</el-radio>
            <el-radio :label="1" v-model="user.disciplineType">理科</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="pattern === 1">
          <el-form-item label="选考科目:" label-width="100px">
            <el-col>
              <el-checkbox-group v-model="user.disciplineTemp" :max="3">
                <el-checkbox label="化学">化学</el-checkbox>
                <el-checkbox label="政治">政治</el-checkbox>
                <el-checkbox label="物理">物理</el-checkbox>
                <el-checkbox label="历史">历史</el-checkbox>
                <el-checkbox label="生物">生物</el-checkbox>
                <el-checkbox label="地理">地理</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="pattern === 2">
          <el-form-item label="选考科目:" label-width="100px">
            <el-radio label="物理" v-model="wulilishi">物理</el-radio>
            <el-radio label="历史" v-model="wulilishi">历史</el-radio>
            <i class="el-icon-minus" style="transform: rotate(90deg); margin-right: 20px"></i>
            <el-checkbox-group v-model="user.disciplineTemp" class="group" :max="2">
              <el-checkbox label="化学">化学</el-checkbox>
              <el-checkbox label="政治">政治</el-checkbox>
              <el-checkbox label="生物">生物</el-checkbox>
              <el-checkbox label="地理">地理</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="国家专项">
            <el-select v-model="user.isNationalSpecial" placeholder="请选择" size="small" style="width: 200px">
              <el-option v-for="item in yesOrNoOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="地方专项">
            <el-select v-model="user.isLocalSpecial" placeholder="请选择" size="small" style="width: 200px">
              <el-option v-for="item in yesOrNoOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="高校专项">
            <el-select v-model="user.isUniversitySpecial" placeholder="请选择" size="small" style="width: 200px">
              <el-option v-for="item in yesOrNoOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="少数民族">
            <el-select v-model="user.isMinority" placeholder="请选择" size="small" style="width: 200px">
              <el-option v-for="item in yesOrNoOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="色觉异常">
            <el-select v-model="user.colorWeakness" placeholder="请选择" size="small" style="width: 200px">
              <el-option v-for="item in abnormalColorOptions" :key="item.value" :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="联系人:" prop="fatherName">
            <el-input style="width: 200px" clearable size="small" v-model="user.fatherName"
                      placeholder="请输入联系人姓名">
            </el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="关系:" prop="fatherShip">
            <el-select
              v-model="user.fatherShip"
              placeholder="请选择关系"
              size="small"
              class="input"
            >
              <el-option
                v-for="item in shipoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="电话:" prop="fatherPhone">
            <el-input style="width: 200px" clearable size="small" v-model="user.fatherPhone"
                      placeholder="请输入联系人电话">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="8">
          <el-form-item label="联系人2:" label-width="100px">
            <el-input
              style="width: 200px"
              clearable
              size="small"
              v-model="user.motherName"
              placeholder="请输入联系人2姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="关系:">
            <el-select
              v-model="user.motherShip"
              placeholder="请选择关系"
              size="small"
              class="input"
            >
              <el-option
                v-for="item in shipoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电话:" label-width="100px">
            <el-input
              style="width: 200px"
              clearable
              size="small"
              v-model="user.motherPhone"
              placeholder="请输入联系人2电话"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col>
          <el-form-item label="学生备注:">
            <el-input style="width: 500px" clearable type="textarea" v-model="user.remark" placeholder="请输入内容"
                      :rows="5"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog title="选择中学" :visible.sync="centerDialogVisible" width="1000px" center>
      <el-form :inline="true" :model="formInline1" class="demo-form-inline">
        <el-form-item label="中学省份:">
          <el-select clearable v-model="formInline1.province" placeholder="请选择中学省份" size="small" class="input">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校名称：">
          <el-input size="small" placeholder="请输入学校名称" v-model="formInline1.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getSchoolInfoList">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-radio v-for="item in optionsschool" :key="item.schoolId" :label="item" v-model="attendedSchool"
                style="width: 200px; margin: 10px" border size="small">{{ item.shortName }}
      </el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="sureschool">确 定</el-button>
      </span>
    </el-dialog>
    <div class="footer">
      <el-button size="small" class="button" @click="goback">返回</el-button>
      <el-button type="primary" size="small" @click="saveShoppOrder">确定</el-button>
    </div>
    <!-- 销售人员 -->
    <el-dialog title="选择销售人员" :visible.sync="centerDialogVisible1" width="50%" center>
      <span>
        <el-form>
          <el-form-item label="销售省份：">
            <el-select @change="getCompany()" v-model="form.province" placeholder="请选择销售省份" size="small"
                       class="input"
                       value-key="id">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售公司：">
            <el-select clearable @change="pageuser" v-model="form.companyId" placeholder="请选择销售公司" size="small"
                       style="width: 200px" :disabled="disable">
              <el-option v-for="item in companyoptions1" :key="item.companyId" :label="item.companyName"
                         :value="item.companyId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="销售人员：">
            <el-input size="small" placeholder="姓名或联系方式" v-model="formInline.keyWord"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="pageuser">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :stripe="true" size="mini" :data="gridData" border
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }" style="width: 100%">
          <el-table-column type="index" label="序号" width="60">
          </el-table-column>
          <el-table-column property="realName" label="姓名" width="120">
          </el-table-column>
          <el-table-column property="six" label="性别" width="80">
          </el-table-column>
          <el-table-column property="phoneNum" label="联系电话">
          </el-table-column>
          <el-table-column property="departmentName" label="所属公司">
          </el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="text" style="font-size: 14px" @click="surechoose(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getProvincePage, getYears} from "@/api/systemManagement.js";
import {getCityList, getCountyList, getProvinceList,} from "@/api/index.js";
import {
  getCompanyList,
  getSchoolInfoList,
  getShoppOrderInfo,
  pageuser,
  perfectInformation,
} from "@/api/commodityManagement.js";
import {isflag} from "@/util/isflag.js";

export default {
  data() {
    return {
      count: 0,
      gkProvince: {},
      nationData: [
        {
          id: "01",
          name: "汉族",
        },
        {
          id: "02",
          name: "蒙古族",
        },
        {
          id: "03",
          name: "回族",
        },
        {
          id: "04",
          name: "藏族",
        },
        {
          id: "05",
          name: "维吾尔族",
        },
        {
          id: "06",
          name: "苗族",
        },
        {
          id: "07",
          name: "彝族",
        },
        {
          id: "08",
          name: "壮族",
        },
        {
          id: "09",
          name: "布依族",
        },
        {
          id: "10",
          name: "朝鲜族",
        },
        {
          id: "11",
          name: "满族",
        },
        {
          id: "12",
          name: "侗族",
        },
        {
          id: "13",
          name: "瑶族",
        },
        {
          id: "14",
          name: "白族",
        },
        {
          id: "15",
          name: "土家族",
        },
        {
          id: "16",
          name: "哈尼族",
        },
        {
          id: "17",
          name: "哈萨克族",
        },
        {
          id: "18",
          name: "傣族",
        },
        {
          id: "19",
          name: "黎族",
        },
        {
          id: "20",
          name: "傈僳族",
        },
        {
          id: "21",
          name: "佤族",
        },
        {
          id: "22",
          name: "畲族",
        },
        {
          id: "23",
          name: "高山族",
        },
        {
          id: "24",
          name: "拉祜族",
        },
        {
          id: "25",
          name: "水族",
        },
        {
          id: "26",
          name: "东乡族",
        },
        {
          id: "27",
          name: "纳西族",
        },
        {
          id: "28",
          name: "景颇族",
        },
        {
          id: "29",
          name: "柯尔克孜族",
        },
        {
          id: "30",
          name: "土族",
        },
        {
          id: "31",
          name: "达斡尔族",
        },
        {
          id: "32",
          name: "仫佬族",
        },
        {
          id: "33",
          name: "羌族",
        },
        {
          id: "34",
          name: "布朗族",
        },
        {
          id: "35",
          name: "撒拉族",
        },
        {
          id: "36",
          name: "毛南族",
        },
        {
          id: "37",
          name: "仡佬族",
        },
        {
          id: "38",
          name: "锡伯族",
        },
        {
          id: "39",
          name: "阿昌族",
        },
        {
          id: "40",
          name: "普米族",
        },
        {
          id: "41",
          name: "塔吉克族",
        },
        {
          id: "42",
          name: "怒族",
        },
        {
          id: "43",
          name: "乌孜别克族",
        },
        {
          id: "44",
          name: "俄罗斯族",
        },
        {
          id: "45",
          name: "鄂温克族",
        },
        {
          id: "46",
          name: "崩龙族",
        },
        {
          id: "47",
          name: "保安族",
        },
        {
          id: "48",
          name: "裕固族",
        },
        {
          id: "49",
          name: "京族",
        },
        {
          id: "50",
          name: "塔塔尔族",
        },
        {
          id: "51",
          name: "独龙族",
        },
        {
          id: "52",
          name: "鄂伦春族",
        },
        {
          id: "53",
          name: "赫哲族",
        },
        {
          id: "54",
          name: "门巴族",
        },
        {
          id: "55",
          name: "珞巴族",
        },
        {
          id: "56",
          name: "基诺族",
        },
        {
          id: "57",
          name: "穿青族",
        },
      ], //民族
      form: {
        isManage: 1,
        isGet: 0,
        user: {},
      },
      pattern: 0,
      wulilishi: "",
      disable: false,
      disable1: false,
      disabled2: true,
      disabled3: true,
      centerDialogVisible1: false,
      attendedSchool: {
        schoolId: ""
      },
      centerDialogVisible: false,
      yearsoptions: [],
      companyoptions: [],
      companyoptions1: [],
      address: {
        city: "",
        province: "",
        area: "",
        address: ""
      },
      shipoptions: [
        {label: "父子", value: "1"},
        {label: "父女", value: "2"},
        {label: " 母子", value: "3"},
        {label: "母女", value: "4"},
        {label: "其他", value: "5"},
      ],
      yesOrNoOptions: [
        {label: "是", value: 1},
        {label: "否", value: 0},
      ],
      abnormalColorOptions: [
        {label: "无", value: 0},
        {label: "Ⅰ度（色弱）", value: 1},
        {label: "Ⅱ度（色盲）", value: 2},
        {label: "Ⅲ度（不能识别颜色）", value: 3},
      ],
      formInline: {},
      formInline1: {},
      user: {
        sex: 0,
        disciplineType: 0,
        discipline: [],
        disciplineTemp: [],
        nation: "汉族",
      },
      optionsschool: [],
      checkList: [],
      province: {}, //省
      city1: {}, //市
      county1: {}, //区
      options: [], //省份
      city: [], //城市
      county: [], //区县
      sysUser: {},
      gridData: [],
      //判断关联产品，新增订单当前步骤只需判断是否同时包含实体类和非实体类，若同时包含实体类和非实体类则需同时填写收货信息和学生信息
      containPhysicalAndServiceProduct: false,
    };
  },
  watch: {
    $route(val) {
      if (val.path === "/newOrderlast") {
        this.count = 0;
        (this.form = {
          isManage: 1,
          user: {},
          isGet: 0,
        }),
            (this.formInline = {});
        this.formInline1 = {};
        let sysUser = window.sessionStorage.getItem("sysUser");
        this.sysUser = JSON.parse(sysUser);
        this.user = {
          sex: 0,
          disciplineType: 0,
          discipline: [],
          disciplineTemp: [],
          nation: "汉族",
        };
        this.address = {
          city: "",
          province: "",
          area: "",
          address: ""
        };
        let id1 = "";
        if (this.sysUser.provincePrerm.includes(",")) {
          let arr = this.sysUser.provincePrerm.split(",");
          if (arr[0] !== "") {
            id1 = arr[0];
          } else {
            id1 = arr[1];
          }
        } else {
          id1 = this.sysUser.provincePrerm;
        }
        if (this.sysUser.sysUserRole === 0 || id1 === "0") {
          this.disabled2 = false;
          this.disabled3 = false;
        } else {
          this.user.company = {
            companyId: this.sysUser.departmentId - 0,
            companyName: this.sysUser.departmentName,
          };
        }
        let id = this.$route.query.id;
        if (id) {
          this.getShoppOrderInfo(id);
        }
        this.getYears();
        this.getCompanyList();
        this.getCompany();
      }
    },
  },
  mounted() {
    let sysUser = window.sessionStorage.getItem("sysUser");
    this.sysUser = JSON.parse(sysUser);
    let id1 = "";
    if (this.sysUser.provincePrerm.includes(",")) {
      let arr = this.sysUser.provincePrerm.split(",");
      if (arr[0] !== "") {
        id1 = arr[0];
      } else {
        id1 = arr[1];
      }
    } else {
      id1 = this.sysUser.provincePrerm;
    }
    if (this.sysUser.sysUserRole === 0 || id1 === "0") {
      this.disabled2 = false;
      this.disabled3 = false;
    } else {
      this.user.company = {
        companyId: this.sysUser.departmentId - 0,
        companyName: this.sysUser.departmentName,
      };
    }
    let id = this.$route.query.id;
    if (id) {
      this.getShoppOrderInfo(id);
    }
    this.getYears();
    this.getCompanyList();
    this.getCompany();
  },
  methods: {
    surechoose(data) {
      this.form.salesman = data.realName;
      this.centerDialogVisible1 = false;
      this.count = this.count + 1;
    },
    showschool() {
      this.centerDialogVisible = true;
      this.getSchoolInfoList();
    },
    sureschool() {
      console.log(this.attendedSchool, "学校");
      this.user.schoolId = this.attendedSchool.schoolId;
      this.user.schoolName = this.attendedSchool.shortName;
      this.centerDialogVisible = false;
    },
    pageuser() {
      let form = {
        departmentId: this.form.companyId,
      };
      pageuser({department: form, keyWord: this.formInline.keyWord}).then(
          (res) => {
            let data = res.data || {};
            this.gridData = data.records || [];
          }
      );
    },
    chooseuser() {
      if (this.count === 0 || this.sysUser.sysUserRole === 0) {
        this.pageuser();
        this.centerDialogVisible1 = true;
      }
    },
    //获取公司
    getCompany() {
      // console.log(this.user, "user");
      getCompanyList({level: 2, provinceId: this.form.provinceId}).then(
          (res) => {
            this.companyoptions1 = res.data || [];
            let obj = this.companyoptions1.filter((item) => {
              return item.id === this.form.companyId;
            });
            this.form.companyName = obj[0].companyName;
            // if (this.sysUser.sysUserRole !=== 0) {
            //   this.user.company = {
            //     companyId: this.sysUser.departmentId - 0,
            //     companyName: this.sysUser.departmentName,
            //   };
            // } else {
            //   this.disabled3 = false;
            // }
          }
      );
    },
    gkprovincechange(val) {
      if (val.name) {
        this.formInline1.province = val.name;
      }
      this.getSchoolInfoList();
      this.handelchange();
    },
    //获取详情
    getShoppOrderInfo(id) {
      getShoppOrderInfo({orderId: id}).then((res) => {
        if (res.code === 1) {
          this.form = res.data || {};

          //判断关联产品 containPhysicalAndServiceProduct
          if (this.form.shoppProduct) {
            //产品不为空
            let product = this.form.shoppProduct;
            let productTypeArr = [];
            productTypeArr.push(product.productType);

            if (product.shoppProducts) {
              product.shoppProducts.forEach((item) => {
                productTypeArr.push(item.productType);
              });
            }
            if (
                productTypeArr.includes(1) &&
                (productTypeArr.includes(2) ||
                    productTypeArr.includes(3) ||
                    productTypeArr.includes(4) ||
                    productTypeArr.includes(5))
            ) {
              //产品类型同时包含实体类和非实体类
              this.containPhysicalAndServiceProduct = true;
              // this.$message.success(
              //   "该订单同时包含实体类和服务类产品，请填写收货信息和学生信息"
              // );
            } else {
              this.containPhysicalAndServiceProduct = false;
            }
          }

          //地址信息
          if (this.form.address) {
            this.address = this.form.address || {}
          }

          this.user.contactPhone = this.form.contactPhone;
          if (this.form.user) {
            this.user = this.form.user || {};
            if (!this.user.sex) {
              this.user.sex = 0;
            }
            this.user.contactPhone = this.form.contactPhone;

            this.user.disciplineTemp = []
            //处理选考科目
            let studentDiscipline = this.user.discipline
            if (studentDiscipline){
              if (this.user.pattern === 3) {
                this.user.disciplineTemp.push(studentDiscipline)
              } else {
                if (studentDiscipline && studentDiscipline.includes(",")) {
                  let  disciplineList = studentDiscipline.split(",")

                  if (this.user.pattern === 2) {
                    disciplineList.forEach(item => {
                      if (item === "物理"){
                        this.wulilishi = "物理";
                      } else if (item === "历史"){
                        this.wulilishi = "历史";
                      } else {
                        this.user.disciplineTemp.push(item)
                      }
                    })
                  } else {
                    this.user.disciplineTemp = [...disciplineList]
                  }
                }
              }
            }


            this.getCompanyList();
            this.getCompany();
            // this.attendedSchool.shortName = this.user.schoolName;
            this.user.company = {
              companyId: this.user.companyId - 0,
              companyName: this.user.companyName,
            };
            this.form.companyId = this.form.companyId
                ? this.form.companyId - 0
                : null;
            if (this.form.companyId) {
              this.disable = true;
            }
            if (this.form.salesman) {
              this.disable1 = true;
            }
            this.getProvinceListData();
          } else {
            this.form.companyId = this.form.companyId
                ? this.form.companyId - 0
                : null;
            if (this.form.companyId) {
              this.disable = true;
            }
            if (this.form.salesman) {
              this.disable1 = true;
            }
            if (this.sysUser.provincePrerm.includes(",")) {
              let arr = this.sysUser.provincePrerm.split(",");
              if (arr[0]) {
                this.user.province = arr[0];
              } else {
                this.user.province = arr[1];
              }
            } else {
              this.user.province = this.sysUser.provincePrerm;
            }
            this.user.sex = 0;
            this.gkProvince.id = this.user.province;
            this.getProvinceListData();
            this.user.realName = this.form.userName;
            this.user.servicePhone = this.form.contactPhone;
            let year = new Date().getFullYear();
            let collegeTime = new Date(year + "/7/1");
            if (new Date().getTime() > collegeTime.getTime()) {
              year += 1;
            }
            this.user.graduateYear = year;
            this.user = {...this.user};
            this.handelchange();
          }
        }
      });
    },
    // 查询所有省份
    getProvinceListData() {
      getProvinceList().then((res) => {
        this.options = res.data || [];
        let id = "";
        if (this.sysUser.provincePrerm.includes(",")) {
          let arr = this.sysUser.provincePrerm.split(",");
          if (arr[0]) {
            id = arr[0];
          } else {
            id = arr[1];
          }
        } else {
          id = this.sysUser.provincePrerm;
        }
        let obj = this.options.filter((item) => {
          return item.id === id;
        });
        console.log(obj, "obj");
        if (this.sysUser.provincePrerm.includes(",")) {
          let arr = this.sysUser.provincePrerm.split(",");
          if (arr[0]) {
            this.user.province = arr[0];
          } else {
            this.user.province = arr[1];
          }
        } else {
          this.user.province = this.sysUser.provincePrerm;
        }
        this.formInline1.province = obj[0].name;
        this.formInline1 = {...this.formInline1};
        this.gkProvince = {
          id: this.user.province,
          name: obj[0].name,
        };
        this.user.residenceProvince1 = {
          id: this.user.province,
          name: obj[0].name,
        };
        this.changeprovince(this.user.residenceProvince1);
      });
    },
    //获取学校
    getSchoolInfoList() {
      // this.formInline.province = this.gkProvince.name
      getSchoolInfoList(this.formInline1).then((res) => {
        this.optionsschool = res.data.slice(0, 20) || [];
      });
    },
    //获取高考模式
    handelchange() {
      getProvincePage({
        year: this.user.graduateYear,
        areaProvinceId: this.gkProvince.id,
      }).then((res) => {
        let data = res.data || {};
        let arr = data.records || [];
        this.user.pattern = arr[0].pattern || "";
        this.pattern = this.user.pattern;
        this.wulilishi = "";
        this.user.discipline = [];
        this.user.disciplineTemp = [];
      });
    },
    //获取公司
    getCompanyList() {
      getCompanyList({level: 2, provinceId: this.form.provinceId}).then(
          (res) => {
            this.companyoptions = res.data || [];
            // if (this.sysUser.sysUserRole !=== 0) {
            //   this.user.company = {
            //     companyId: this.sysUser.departmentId - 0,
            //     companyName: this.sysUser.departmentName,
            //   };
            //   console.log(this.user.company, "this.user.company");
            // } else {
            //   this.disabled3 = false;
            // }
          }
      );
    },
    //获取年份
    async getYears() {
      await getYears().then((res) => {
        console.log(res, "year");
        this.yearsoptions = res.data || [];
      });
    },
    goback() {
      this.$router.push("/2.2");
    },
    //确定
    saveShoppOrder() {
      let reg_tel =
          /^1((3[0-9])|(4[01456879])|(5[0-9])|(6[2567])|(7[0-9])|(8[0-9])|(9[0-9]))\d{8}$/;

      // this.$refs.form.validate((valid) => {
      this.user.province = this.gkProvince.id;
      this.user.examProvince = this.gkProvince.name;
      this.form.companyId = this.form.companyId
          ? this.form.companyId + ""
          : null;
      this.form.isManage = 1;
      if (this.containPhysicalAndServiceProduct) {
        //同时包含实体类和非实体类

        if (!isflag(this.form.isGet)) {
          this.$message.error("请选择是否取货");
          return;
        }
        if (this.form.isGet === 1) {
          if (!this.address.consignee) {
            this.$message.error("请输入收货人");
            return;
          }
          if (!this.address.telephone) {
            this.$message.error("请输入收货电话");
            return;
          }

          if (!reg_tel.test(this.address.telephone)) {
            this.$message.error("收货电话格式错误");
            return false;
          }
          if (
              !this.address.province ||
              !this.address.city ||
              !this.address.area
          ) {
            this.$message.error("请选择邮寄地址");
            return;
          }
          if (!this.address.address) {
            this.$message.error("请输入详细地址");
            return;
          }
        }

        this.form.address = {};
        this.form.address.area = this.address.area.name;
        this.form.address.city = this.address.city.name;
        this.form.address.province = this.address.province.name;
        this.form.address.address = this.address.address;
        this.form.address.consignee = this.address.consignee;
        this.form.address.telephone = this.address.telephone;


        this.form.user = this.user;
        if (!this.user.schoolId) {
          this.$message.error("请选择学校");
          return;
        }
        if (!this.form.user.company) {
          this.$message.error("请选择所属公司");
          return;
        }
        if (!this.user.residenceProvince1.name) {
          this.$message.error("请选择户籍省份");
          return;
        }
        if (!this.user.residenceCity1.name) {
          this.$message.error("请选择户籍城市");
          return;
        }
        if (!this.user.examProvince) {
          this.$message.error("请选择高考省份");
          return;
        }
        if (this.user.pattern === 1) {
          if (this.user.disciplineTemp.length !== 3) {
            this.$message.error("请选择科目");
            return;
          }
        } else if (this.user.pattern === 2) {
          if (this.user.disciplineTemp.length !== 2 || !this.wulilishi) {
            this.$message.error("请选择科目");
            return;
          }
        } else {
          if (
              this.form.user.disciplineType !== 2 &&
              this.form.user.disciplineType !== 1
          ) {
            this.$message.error("请选择科目");
            return;
          }
        }
        if (this.user.pattern === 1) {
          this.form.user.disciplineType = 0;
        }
        if (this.wulilishi === "物理") {
          this.form.user.disciplineType = 3;
        }
        if (this.wulilishi === "历史") {
          this.form.user.disciplineType = 4;
        }
        if (!isflag(this.user.isNationalSpecial)) {
          this.$message.error("请选择是否国家专项");
          return;
        }
        if (!isflag(this.user.isLocalSpecial)) {
          this.$message.error("请选择是否地方专项");
          return;
        }
        if (!isflag(this.user.isUniversitySpecial)) {
          this.$message.error("请选择是否高校专项");
          return;
        }
        if (!isflag(this.user.isMinority)) {
          this.$message.error("请选择是否少数民族");
          return;
        }
        if (!isflag(this.user.colorWeakness)) {
          this.$message.error("请选择是否色觉异常");
          return;
        }
        if (!this.form.user.fatherName) {
          this.$message.error("请输入联系人姓名");
          return;
        }
        // if (!this.form.user.fatherShip) {
        //   this.$message.error("请选择与联系人1关系");
        //   return;
        // }
        if (!this.form.user.fatherPhone) {
          this.$message.error("请输入联系人电话");
          return;
        }
        if (
            this.form.user.fatherPhone &&
            !reg_tel.test(this.form.user.fatherPhone)
        ) {
          this.$message.error("联系人电话格式错误");
          return;
        }
        if (this.user.pattern === 1){
          this.user.discipline = this.user.disciplineTemp.toString();
        } else if (this.user.pattern === 2) {
          this.user.discipline = this.wulilishi + "," + this.user.disciplineTemp.toString() ;
        } else {
          if (this.user.disciplineType === 1){
            this.user.discipline = "理科"
          } else if (this.user.disciplineType === 2){
            this.user.discipline = "文科"
          }
        }
        if (this.user.pattern === 1) {
          this.form.user.disciplineType = 0;
        }
        if (this.wulilishi === "物理") {
          this.form.user.disciplineType = 3;
        }
        if (this.wulilishi === "历史") {
          this.form.user.disciplineType = 4;
        }

        this.form.user.companyId = this.form.user.company.companyId;
        this.form.user.companyName = this.form.user.company.companyName;
        this.form.user.residenceCity = this.user.residenceCity1.name
            ? this.user.residenceCity1.name
            : this.form.user.residenceCity;
        this.form.user.residenceProvince = this.user.residenceProvince1.name
            ? this.user.residenceProvince1.name
            : this.form.user.residenceProvince;
      } else {
        if (this.form.productType === 1) {
          if (!isflag(this.form.isGet)) {
            this.$message.error("请选择是否取货");
            return;
          }
          if (this.form.isGet === 1) {
            if (!this.address.consignee) {
              this.$message.error("请输入收货人");
              return;
            }
            if (!this.address.telephone) {
              this.$message.error("请输入收货电话");
              return;
            }
            if (!reg_tel.test(this.address.telephone)) {
              this.$message.error("收货电话格式错误");
              return false;
            }
            if (
                !this.address.province ||
                !this.address.city ||
                !this.address.area
            ) {
              this.$message.error("请选择邮寄地址");
              return;
            }
            if (!this.address.address) {
              this.$message.error("请输入详细地址");
              return;
            }
          }

          this.form.address = {};
          this.form.address.area = this.address.area.name;
          this.form.address.city = this.address.city.name;
          this.form.address.province = this.address.province.name;
          this.form.address.address = this.address.address;
          this.form.address.consignee = this.address.consignee;
          this.form.address.telephone = this.address.telephone;

          console.log(this.form.address, "邮寄地址")
        } else {
          this.form.user = this.user;
          if (!this.user.schoolId) {
            this.$message.error("请选择学校");
            return;
          }
          if (!this.form.user.company) {
            this.$message.error("请选择所属公司");
            return;
          }
          if (!this.user.residenceProvince1.name) {
            this.$message.error("请选择户籍省份");
            return;
          }
          if (!this.user.residenceCity1.name) {
            this.$message.error("请选择户籍城市");
            return;
          }
          if (!this.user.examProvince) {
            this.$message.error("请选择高考省份");
            return;
          }
          if (this.user.pattern === 1) {
            if (this.user.disciplineTemp.length !== 3) {
              this.$message.error("请选择科目");
              return;
            }
          } else if (this.user.pattern === 2) {
            if (this.user.disciplineTemp.length !== 2 || !this.wulilishi) {
              this.$message.error("请选择科目");
              return;
            }
          } else {
            if (
                this.form.user.disciplineType !== 2 &&
                this.form.user.disciplineType !== 1
            ) {
              this.$message.error("请选择科目");
              return;
            }
          }
          if (this.user.pattern === 1) {
            this.form.user.disciplineType = 0;
          }
          if (this.wulilishi === "物理") {
            this.form.user.disciplineType = 3;
          }
          if (this.wulilishi === "历史") {
            this.form.user.disciplineType = 4;
          }
          if (!isflag(this.user.isNationalSpecial)) {
            this.$message.error("请选择是否国家专项");
            return;
          }
          if (!isflag(this.user.isLocalSpecial)) {
            this.$message.error("请选择是否地方专项");
            return;
          }
          if (!isflag(this.user.isUniversitySpecial)) {
            this.$message.error("请选择是否高校专项");
            return;
          }
          if (!isflag(this.user.isMinority)) {
            this.$message.error("请选择是否少数民族");
            return;
          }
          if (!isflag(this.user.colorWeakness)) {
            this.$message.error("请选择是否色觉异常");
            return;
          }
          if (!this.form.user.fatherName) {
            this.$message.error("请输入联系人姓名");
            return;
          }
          if (!this.form.user.fatherPhone) {
            this.$message.error("请输入联系人电话");
            return;
          }
          if (
              this.form.user.fatherPhone &&
              !reg_tel.test(this.form.user.fatherPhone)
          ) {
            this.$message.error("联系人电话格式错误");
            return;
          }
          if (this.user.pattern === 1){
            this.user.discipline = this.user.disciplineTemp.toString();
          } else if (this.user.pattern === 2) {
            this.user.discipline = this.wulilishi + "," + this.user.disciplineTemp.toString() ;
          } else {
            if (this.user.disciplineType === 1){
              this.user.discipline = "理科"
            } else if (this.user.disciplineType === 2){
              this.user.discipline = "文科"
            }
          }
          if (this.user.pattern === 1) {
            this.form.user.disciplineType = 0;
          }
          if (this.wulilishi === "物理") {
            this.form.user.disciplineType = 3;
          }
          if (this.wulilishi === "历史") {
            this.form.user.disciplineType = 4;
          }

          this.form.user.companyId = this.form.user.company.companyId;
          this.form.user.companyName = this.form.user.company.companyName;
          this.form.user.residenceCity = this.user.residenceCity1.name
              ? this.user.residenceCity1.name
              : this.form.user.residenceCity;
          this.form.user.residenceProvince = this.user.residenceProvince1.name
              ? this.user.residenceProvince1.name
              : this.form.user.residenceProvince;
        }
      }
      perfectInformation(this.form).then((res) => {
        if (res.code === 1) {
          this.$router.push("/2.2");
        }
      });
    },
    // 获取城市
    getCityListData(id) {
      getCityList({id: id}).then((res) => {
        if (res.code === 1) {
          this.city = res.data;
        }
      });
    },
    //省份改变
    changeprovince({id}) {
      this.getCityListData(id);
      this.user.residenceCity1 = {};
      this.user.residenceCounty = "";
    },
    //城市改变
    changecity({id}) {
      this.getCountyListData(id);
      this.user.residenceCounty = "";
    },
    // 查询区县
    getCountyListData(id) {
      getCountyList({id: id}).then((res) => {
        this.county = res.data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.bigbox {
  padding: 20px;

  .title {
    padding-left: 20px;
    margin-top: 20px;
    margin-bottom: 20px;

    //   margin-bottom: 20px;
    .titleline {
      display: inline-block;
      width: 6px;
      height: 24px;
      margin-right: 10px;
      background-color: #1ab394;
      border-radius: 3px;
    }

    .titletext {
      display: inline-block;
      font-weight: 600;
      color: #000;
      vertical-align: top;
    }
  }

  /deep/ .input1 {
    width: 150px !important;
    margin-right: 20px !important;
  }

  /deep/ .group {
    display: inline-block;
  }

  .radio {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    .span {
      display: inline-block;
      width: 300px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      margin: 10px;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 80px;

    .button {
      margin-right: 300px;
    }
  }

  .spanorder {
    display: inline-block;
    border: 1px solid #f0f0f0;
    padding: 0px 10px;
    border-radius: 5px;
    background-color: #f0f0f0;
  }
}
</style>
